var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBeppolicemanRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.5C4.09375 6.5 5 5.625 5 4.5C5 3.40625 4.09375 2.5 3 2.5C1.875 2.5 1 3.40625 1 4.5C1 5.625 1.875 6.5 3 6.5ZM17 6.5C18.0938 6.5 19 5.625 19 4.5C19 3.40625 18.0938 2.5 17 2.5C15.875 2.5 15 3.40625 15 4.5C15 5.625 15.875 6.5 17 6.5ZM18 7.5H16C15.4375 7.5 14.9375 7.75 14.5625 8.09375C15.8438 8.78125 16.7188 10.0312 16.9375 11.5H19C19.5312 11.5 20 11.0625 20 10.5V9.5C20 8.40625 19.0938 7.5 18 7.5ZM10 7.5C11.9062 7.5 13.5 5.9375 13.5 4C13.5 2.09375 11.9062 0.5 10 0.5C8.0625 0.5 6.5 2.09375 6.5 4C6.5 5.9375 8.0625 7.5 10 7.5ZM12.375 8.5H12.125C11.4688 8.8125 10.75 9 10 9C9.21875 9 8.5 8.8125 7.84375 8.5H7.59375C5.59375 8.5 4 10.125 4 12.125V13C4 13.8438 4.65625 14.5 5.5 14.5H14.5C15.3125 14.5 16 13.8438 16 13V12.125C16 10.125 14.375 8.5 12.375 8.5ZM5.40625 8.09375C5.03125 7.75 4.53125 7.5 4 7.5H2C0.875 7.5 0 8.40625 0 9.5V10.5C0 11.0625 0.4375 11.5 1 11.5H3.03125C3.25 10.0312 4.125 8.78125 5.40625 8.09375Z",
    fill: "#005A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBeppolicemanRequest);
export default __webpack_public_path__ + "static/media/blueBeppolicemanRequest.06f4589ecb593288891b305172a9c6e6.svg";
export { ForwardRef as ReactComponent };